export default __webpack_public_path__ + "static/media/08.24f35653.png";